import { lazy } from 'react';
import { retry } from '../../config/utils';

const InputOTP = lazy(() =>  retry(()=> import(/* webpackChunkName: "otp-input" */ "./index")));

export default InputOTP;